/* eslint-disable sonarjs/no-duplicate-string, sonarjs/cognitive-complexity */
import {WIX_ECOM} from '@wix/app-definition-ids';
import {PageMap, StoresWidgetID} from '@wix/wixstores-client-core/dist/es/src/constants';
import {EditorSDK} from '@wix/platform-editor-sdk';

export const SuccessPopupControllerName = 'successPopupLightboxController';

export const createSuccessPopupLightbox = async (
  sdk: EditorSDK,
  managingAppDefId: string,
  isResponsive: boolean = false,
  t: (key: string) => string
) => {
  const tpaApplicationId = (await sdk.tpa.app.getDataByAppDefId('', WIX_ECOM)).applicationId;

  const options = {
    title: t('pages_panel_ecomPlatform_successPopUp'),
    hideTitle: true,
    shouldNavigateToPage: false,
    controllerType: SuccessPopupControllerName,
    popupRole: PageMap.SUCCESS_POPUP,
    definition: {
      data: {
        tpaApplicationId,
        tpaPageId: PageMap.SUCCESS_POPUP,
        managingAppDefId,
        appDefinitionId: WIX_ECOM,
        ...(!isResponsive
          ? {
              pageBackgrounds: {
                desktop: {
                  custom: true,
                  ref: {
                    type: 'BackgroundMedia',
                    color: '{color_15}',
                    colorOpacity: 0.3,
                    alignType: 'top',
                    fittingType: 'fill',
                    scrollType: 'fixed',
                  },
                  isPreset: true,
                },
                mobile: {
                  custom: true,
                  ref: {
                    type: 'BackgroundMedia',
                    color: '{color_15}',
                    colorOpacity: 0.3,
                    alignType: 'top',
                    fittingType: 'fill',
                    scrollType: 'fixed',
                  },
                  isPreset: true,
                },
              },
            }
          : {}),
      },
      components: [
        {
          type: 'Container',
          skin: isResponsive
            ? 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG'
            : 'wysiwyg.viewer.skins.stripContainer.DefaultStripContainer',
          layout: isResponsive
            ? {x: 620, fixedPosition: false, y: 80, scale: 1, height: 300, rotationInDegrees: 0, width: 350}
            : {width: 350, height: 300, x: 957, y: 90, scale: 1, rotationInDegrees: 0, fixedPosition: false},
          componentType: 'wysiwyg.viewer.components.PopupContainer',
          components: [
            {
              type: 'Component',
              skin: 'wysiwyg.viewer.skins.TPASectionSkin',
              layout: {
                width: 350,
                height: 300,
                x: 0,
                y: 0,
                scale: 1,
                rotationInDegrees: 0,
                fixedPosition: false,
              },
              ...(isResponsive
                ? {
                    layouts: {
                      containerLayout: {},
                      componentLayout: {
                        hidden: false,
                        minHeight: {type: 'px', value: 300},
                        height: {type: 'auto'},
                        type: 'ComponentLayout',
                        width: {type: 'percentage', value: 100},
                      },
                      itemLayout: {
                        alignSelf: 'center',
                        margins: {
                          left: {type: 'percentage', value: 0},
                          right: {type: 'percentage', value: 0},
                          top: {type: 'percentage', value: 0},
                          bottom: {type: 'percentage', value: 0},
                        },
                        justifySelf: 'center',
                        type: 'FixedItemLayout',
                      },
                      type: 'SingleLayoutData',
                    },
                  }
                : {}),
              componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
              data: {
                type: 'TPAMultiSection',
                applicationId: tpaApplicationId.toString(),
                appDefinitionId: WIX_ECOM,
                widgetId: StoresWidgetID.SUCCESS_POPUP,
              },
            },
          ],
          props: {
            type: 'PopupContainerProperties',
            alignmentType: 'nineGrid',
            horizontalAlignment: isResponsive ? 'center' : 'right',
            verticalAlignment: isResponsive ? 'center' : 'top',
            horizontalOffset: 0,
            verticalOffset: isResponsive ? 0 : 90,
          },
          design: {
            type: 'MediaContainerDesignData',
            background: {
              type: 'BackgroundMedia',
              color: isResponsive ? '#FFFFFE' : '#FFFFFF',
              colorOpacity: 1,
              fittingType: 'fill',
              alignType: 'center',
              colorOverlay: '',
              colorOverlayOpacity: 0,
              scrollType: 'none',
              ...(!isResponsive ? {showOverlayForMediaType: 'WixVideo'} : {}),
            },
            ...(!isResponsive ? {dataChangeBehaviors: []} : {}),
          },
          style: {
            type: 'ComponentStyle',
            style: {
              properties: {
                'alpha-bg': '1',
                bg: isResponsive ? 'color_11' : 'rgba(255,255,255,1)',
              },
              propertiesSource: {
                'alpha-bg': 'value',
                bg: isResponsive ? 'theme' : 'value',
              },
              groups: {},
            },
            componentClassName: 'wysiwyg.viewer.components.PopupContainer',
            styleType: 'custom',
            skin: isResponsive
              ? 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG'
              : 'wysiwyg.viewer.skins.stripContainer.DefaultStripContainer',
          },
          ...(isResponsive
            ? {
                layouts: {
                  containerLayout: {},
                  spx: {refWidth: 1280, resolverType: 'scale'},
                  componentLayout: {
                    minHeight: {type: 'px', value: 300},
                    hidden: false,
                    height: {type: 'auto'},
                    minWidth: {type: 'px', value: 0},
                    type: 'ComponentLayout',
                    width: {type: 'px', value: 350},
                    maxWidth: {type: 'px', value: 99999},
                    maxHeight: {type: 'px', value: 99999},
                  },
                  itemLayout: {
                    type: 'FixedItemLayout',
                    margins: {
                      left: {type: 'px', value: 0},
                      right: {type: 'px', value: 0},
                      top: {type: 'px', value: 90},
                      bottom: {type: 'px', value: 0},
                    },
                    justifySelf: 'end',
                    alignSelf: 'start',
                  },
                  type: 'SingleLayoutData',
                },
                scopedLayouts: {
                  'variants-morc3tgi2': {
                    containerLayout: {
                      columnGap: {type: 'px', value: 0},
                      rowGap: {type: 'px', value: 0},
                      columns: [{type: 'MinMaxSize', min: {type: 'px', value: 0}, max: {type: 'fr', value: 350}}],
                      type: 'GridContainerLayout',
                      rows: [{type: 'MinMaxSize', min: {type: 'px', value: 300}, max: {type: 'auto'}}],
                    },
                    spx: {refWidth: 390, resolverType: 'scale'},
                    componentLayout: {
                      minHeight: {type: 'px', value: 300},
                      hidden: false,
                      height: {type: 'auto'},
                      minWidth: {type: 'px', value: 0},
                      type: 'ComponentLayout',
                      width: {type: 'px', value: 350},
                      maxWidth: {type: 'px', value: 99999},
                      maxHeight: {type: 'px', value: 99999},
                    },
                    itemLayout: {
                      type: 'FixedItemLayout',
                      margins: {
                        left: {type: 'px', value: 0},
                        right: {type: 'px', value: 0},
                        top: {type: 'px', value: 0},
                        bottom: {type: 'px', value: 0},
                      },
                      justifySelf: 'center',
                      alignSelf: 'center',
                    },
                    type: 'SingleLayoutData',
                  },
                  'variants-morc3tgi3': {
                    containerLayout: {
                      columnGap: {type: 'px', value: 0},
                      rowGap: {type: 'px', value: 0},
                      columns: [{type: 'MinMaxSize', min: {type: 'px', value: 0}, max: {type: 'fr', value: 280}}],
                      type: 'GridContainerLayout',
                      rows: [{type: 'MinMaxSize', min: {type: 'px', value: 300}, max: {type: 'auto'}}],
                    },
                    spx: {refWidth: 390, resolverType: 'scale'},
                    componentLayout: {
                      minHeight: {type: 'px', value: 300},
                      hidden: false,
                      height: {type: 'auto'},
                      minWidth: {type: 'px', value: 0},
                      type: 'ComponentLayout',
                      width: {type: 'px', value: 280},
                      maxWidth: {type: 'px', value: 99999},
                      maxHeight: {type: 'px', value: 99999},
                    },
                    itemLayout: {
                      type: 'FixedItemLayout',
                      margins: {
                        left: {type: 'px', value: 0},
                        right: {type: 'px', value: 0},
                        top: {type: 'px', value: 0},
                        bottom: {type: 'px', value: 0},
                      },
                      justifySelf: 'center',
                      alignSelf: 'center',
                    },
                    type: 'SingleLayoutData',
                  },
                },
                scopedStyles: {
                  'variants-morc3tgi2': {
                    styleType: 'custom',
                    componentClassName: 'wysiwyg.viewer.components.PopupContainer',
                    style: {
                      properties: {'alpha-bg': '1', bg: 'color_11'},
                      propertiesSource: {'alpha-bg': 'value', bg: 'theme'},
                      groups: {},
                    },
                    type: 'ComponentStyle',
                    skin: 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG',
                  },
                  'variants-morc3tgi3': {
                    styleType: 'custom',
                    componentClassName: 'wysiwyg.viewer.components.PopupContainer',
                    style: {
                      properties: {'alpha-bg': '1', bg: 'color_11'},
                      propertiesSource: {'alpha-bg': 'value', bg: 'theme'},
                      groups: {},
                    },
                    type: 'ComponentStyle',
                    skin: 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG',
                  },
                },
                referredVariants: {
                  'variants-morc3tgi2': {
                    pointer: {id: 'variants-morc3tgi2', type: 'variants'},
                    data: {canvasSize: 768, min: 320, id: 'variants-morc3tgi2', max: 1000, type: 'BreakpointRange'},
                  },
                  'variants-morc3tgi3': {
                    pointer: {id: 'variants-morc3tgi3', type: 'variants'},
                    data: {canvasSize: 390, min: 320, id: 'variants-morc3tgi3', max: 750, type: 'BreakpointRange'},
                  },
                },
              }
            : {}),
        },
      ],
      style: {
        ...(isResponsive
          ? {
              styleType: 'custom',
              style: {
                properties: {'alpha-bg': '0.3', bg: 'color_15'},
                propertiesSource: {'alpha-bg': 'value', bg: 'theme'},
                groups: {},
              },
              type: 'ComponentStyle',
              skin: 'wysiwyg.viewer.skins.page.ResponsivePageWithColorBG',
            }
          : {}),
      },
    },
  } as any;

  return sdk.document.pages.popupPages.addConnected('', options);
};
